// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"529":"244e576f","794":"413f2dc4"}[chunkId] + ".css";
};